import styles from "./Plans.module.scss";

const Plans = () => {
  return <>Plans</>;
};

export default Plans;
